import React, { forwardRef, ReactElement, Ref } from 'react'

import { Color } from '../../enums/color'
import { Button, ButtonProps } from '../Button'
import { IconName } from '../Icon'

const PILL_BORDER_RADIUS = '30px'
export interface IconButtonProps extends Omit<ButtonProps, 'icon' | 'color' | 'fullRound' | 'borderRadius'> {
  color?: Color
  icon: IconName
  shape?: 'round' | 'pill'
  onItemClick?: (id?: string) => void
}

export const IconButton = forwardRef(
  (
    { color, variant = 'text', size = 'sm', shape = 'round', fullWidth, ...rest }: IconButtonProps,
    forwardedRef: Ref<HTMLButtonElement>,
  ): ReactElement => (
    <Button
      role="icon-button"
      ref={forwardedRef}
      variant={variant}
      size={size}
      fullWidth={shape === 'pill' || fullWidth}
      fullRound={shape === 'round'}
      borderRadius={shape === 'pill' ? PILL_BORDER_RADIUS : undefined}
      {...rest}
    />
  ),
)
